import { Socket, io } from 'socket.io-client';

class ClientSocket {
  private io: Socket;
  private userId: number = 0;

  constructor() {
    this.io = io(`${HTTP_PROTOCOL}://${CLIENT_SOCKET_URL}`);
  }

  get socket() {
    return this.io
  }

  public setUser(userId: number) {
    this.userId = userId;
  }

  public initChat(callbackMessage: Function, callbackCount: Function) {
    this.io.emit("online", this.userId);

    this.io.on("session", e => callbackMessage(e));

    this.io.emit("chatHistoryOfUnread", { userId: this.userId });
    this.io.on("chatHistoryOfUnread", e => callbackCount(e));
  }

  public initTask(context: any, callback: Function) {
    this.io.on("task", e => callback.call(context, e))
  }

  public close() {
    this.io.close();
  }
}

export default new ClientSocket();
